const SUB = "₀₁₂₃₄₅₆₇₈₉";

export const SUBSCRIPTS = SUB.split("");
export const EXTRA_SYMBOLS = ["·", "⁺", "⁻", "→"];

export const toSubscript = (s) => s.replace(/\d/g, (d) => SUB[Number(d)]);

const TR = { ı: "i", İ: "i", I: "i", ş: "s", Ş: "s", ğ: "g", Ğ: "g", ç: "c", Ç: "c", ö: "o", Ö: "o", ü: "u", Ü: "u" };

export function trNormalize(s) {
  return (s || "")
    .replace(/[₀-₉]/g, (c) => String(SUB.indexOf(c)))
    .replace(/[ıİIşŞğĞçÇöÖüÜ]/g, (c) => TR[c])
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}

export const TYPE_LABELS = { multiple_choice: "Çoktan seçmeli", true_false: "Doğru / Yanlış", matching: "Eşleştirme", classification: "Sınıflandırma", guess: "Tahmin" };
export const hasData = (t) => isStructured(t) || t === "guess";
export const isStructured = (t) => t === "matching" || t === "classification";

export const dataTexts = (q) => {
  const d = q.data || {};
  return [...(d.pairs || []).flatMap((p) => [p.left, p.right]), ...(d.categories || []).map((c) => c.name), ...(d.items || []).map((i) => i.text), ...(d.answers || [])];
};
export const POINT_LEVELS = [10, 20, 30, 40];

const BADGES = {
  10: "bg-slate-800 text-slate-200 border-slate-600",
  20: "bg-blue-950/70 text-blue-300 border-blue-800",
  30: "bg-amber-950/70 text-amber-300 border-amber-700",
  40: "bg-emerald-950/70 text-emerald-300 border-emerald-700",
};

export const pointBadge = (p) => BADGES[p] || "bg-fuchsia-950/60 text-fuchsia-300 border-fuchsia-800";
